import type { LookupReturnFieldState, LookupSchemaFieldOption } from './lookup-schema-setup-types';
import styles from './LookupTool.module.css';

interface LookupSchemaReturnFieldRowProps {
  field: LookupSchemaFieldOption;
  selection: LookupReturnFieldState;
  onIncludedChange: (included: boolean) => void;
  onReturnNameChange: (returnName: string) => void;
}

export const LookupSchemaReturnFieldRow = ({
  field,
  selection,
  onIncludedChange,
  onReturnNameChange,
}: LookupSchemaReturnFieldRowProps) => (
  <li>
    <label className={styles.returnToggle}>
      <input
        type="checkbox"
        aria-label={`Return ${field.name}`}
        checked={selection.included}
        onChange={event => onIncludedChange(event.target.checked)}
      />
      <strong>{field.name}</strong>
      <small>{field.type}</small>
    </label>
    <label className={styles.returnName}>
      Exposure name
      <input
        aria-label={`${field.name} exposure name`}
        type="text"
        value={selection.returnName}
        disabled={!selection.included}
        required={selection.included}
        onChange={event => onReturnNameChange(event.target.value)}
      />
    </label>
  </li>
);
